import {Component, OnInit, ViewChild} from '@angular/core';
import {AddressSectionComponent} from '../address-section/address-section.component';
import {IAddress} from '../../interfaces/address/address.interface';

@Component({
  selector: 'app-clinic-register-address',
  templateUrl: './clinic-register-address.component.html',
  styleUrls: ['./clinic-register-address.component.scss']
})
export class ClinicRegisterAddressComponent implements OnInit {

  @ViewChild(AddressSectionComponent) addressSectionComponent: AddressSectionComponent;
  constructor() { }

  ngOnInit(): void {
  }

  validate(): void {
    this.addressSectionComponent?.formAddress?.form?.markAllAsTouched();
  }

  getValue(): IAddress {
    if (this.addressSectionComponent?.formAddress?.valid) {
      return this.addressSectionComponent?.formAddress?.value;
    }
    return null;
  }
}
